import { useBidOrchestratorDriver } from "./useBidOrchestratorDriver";

/**
 * Mount point for {@link useBidOrchestratorDriver}. A dedicated leaf (rather than
 * calling the hook directly in AppShell) keeps the upload-progress re-renders the
 * driver subscribes to isolated to this null-rendering component instead of
 * re-rendering the whole app shell on every upload tick.
 *
 * Must sit below both `BidOrchestratorStreamProvider` and
 * `DocumentUploadProgressProvider` so the hook can read both contexts.
 */
export function BidOrchestratorDriverHost() {
  useBidOrchestratorDriver();
  return null;
}
